import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, TitleStrategy } from '@angular/router';
import { authInterceptor, errorInterceptor, LogtoAuthService } from '@web-client/auth';
import { CustomPageTitleStrategy, ThemeService } from '@web-client/design-system';
import { ADMIN_APP_ROUTE_PROVIDER, ENVIRONMENT_CONFIG } from '@web-client/shared';
import { provideAuth } from 'angular-auth-oidc-client';
import { buildAngularAuthConfig } from '@logto/angular'
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    ThemeService,
    // Logto Authentication Configuration
    provideAuth({
      config: buildAngularAuthConfig({
        endpoint: environment.logtoEndpoint,
        appId: environment.logtoAppId,
        redirectUri: `${environment.adminAppUrl}/callback`,
        postLogoutRedirectUri: environment.adminAppUrl,
        scopes: ['openid', 'profile', 'email', 'offline_access', 'blogs:read'],
        resource: environment.apiResource, // Request JWT tokens for API
      }),
    }),
    LogtoAuthService, // Provide Logto auth service
    {
      provide: ENVIRONMENT_CONFIG,
      useValue: environment
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } as MatFormFieldDefaultOptions
    },
    {
      provide: TitleStrategy,
      useClass: CustomPageTitleStrategy
    },
    ADMIN_APP_ROUTE_PROVIDER
  ],
};
